// Native shell bootstrap — no-ops on web.
// Uses window.Capacitor / Plugins only (no static @capacitor/* imports) so
// CRA localhost keeps working even before `npm install` pulls Capacitor deps.

import { getCapacitor, isNativeApp } from "./utils/nativePlatform";
import { configureRevenueCatBilling } from "./utils/revenueCatBilling";

async function configureStatusBar(cap) {
    const StatusBar = cap.Plugins && cap.Plugins.StatusBar;
    if (!StatusBar) {
        return;
    }

    try {
        if (typeof StatusBar.setStyle === "function") {
            await StatusBar.setStyle({ style: "DARK" });
        }
        if (
            cap.getPlatform() === "android" &&
            typeof StatusBar.setBackgroundColor === "function"
        ) {
            await StatusBar.setBackgroundColor({ color: "#0b1c2c" });
        }
    } catch (_) {
        // Plugin unavailable outside a native shell.
    }
}

async function lockPortraitOrientation(cap) {
    const ScreenOrientation = cap.Plugins && cap.Plugins.ScreenOrientation;
    if (!ScreenOrientation || typeof ScreenOrientation.lock !== "function") {
        return;
    }

    try {
        await ScreenOrientation.lock({ orientation: "portrait" });
    } catch (_) {
        // Plugin optional; Info.plist still locks iOS.
    }
}

async function hideSplashWhenReady(cap) {
    const SplashScreen = cap.Plugins && cap.Plugins.SplashScreen;
    if (!SplashScreen || typeof SplashScreen.hide !== "function") {
        return;
    }

    try {
        await SplashScreen.hide();
    } catch (_) {
        // Ignore on web / when auto-hide already ran.
    }
}

function wireAppLifecycle(cap) {
    const CapApp = cap.Plugins && cap.Plugins.App;
    if (!CapApp || typeof CapApp.addListener !== "function") {
        return;
    }

    try {
        CapApp.addListener("backButton", ({ canGoBack }) => {
            if (canGoBack) {
                window.history.back();
            } else if (typeof CapApp.exitApp === "function") {
                CapApp.exitApp();
            }
        });
    } catch (_) {
        // App plugin unused on web.
    }
}

/**
 * Initialize Capacitor plugins when running as a native app.
 * Safe to call unconditionally — exits immediately on web.
 */
export async function bootstrapNativeShell() {
    if (!isNativeApp()) {
        return { native: false };
    }

    const cap = getCapacitor();
    if (!cap) {
        return { native: false };
    }

    wireAppLifecycle(cap);
    await configureStatusBar(cap);
    await lockPortraitOrientation(cap);
    await hideSplashWhenReady(cap);

    try {
        await configureRevenueCatBilling();
    } catch (_) {
        // Stay on preview adapter if configure fails (keys still Replace later).
    }

    return {
        native: true,
        platform:
            typeof cap.getPlatform === "function"
                ? cap.getPlatform()
                : "unknown",
    };
}
